import { type PropsWithChildren, useMemo } from 'react';

import { CatalogContext, type CatalogContextValue } from './catalogContext';
import { createCatalogComposition } from './catalogComposition';

export function CatalogProvider({
  children,
  value,
}: PropsWithChildren<{ value?: CatalogContextValue }>) {
  const composition = useMemo(() => value ?? createCatalogComposition(), [value]);
  return <CatalogContext.Provider value={composition}>{children}</CatalogContext.Provider>;
}
